import { useParams, Link } from "react-router-dom";
import { Api } from "src/core/services/api.services";
import LayoutMain from "src/shared/layouts/LayoutMain/LayoutMain";
import { Brief } from "src/shared/interface/brief";
import { useQuery } from "@tanstack/react-query";
import BcLoading from "src/shared/components/Bc-Loading/Bc-Loading";
import BCTag from "src/shared/components/Bc-Tag/Bc-Tag";
import { BCViewBrief } from "src/shared/styled/global.styled";
import { pdf } from "@react-pdf/renderer";
import saveAs from "file-saver";
import BcPdf from "src/shared/components/Bc-pdf/Bc-pdf";
import { convertirABase64 } from "src/helper/toBase64";

const getBriefId = async (id: string) => {
  const { data } = await Api.Brief().then((api) => api.getId<Brief>(id));
  return data;
};

const BriefView = () => {
  const { id } = useParams();

  if (id) console.log(id);

  const serviceQuery = useQuery({
    queryKey: ["brief", id],
    queryFn: () => getBriefId(id as string),
  });

  const generatePdfDocument = async (fileName: string, pdfDocumentComponent: any) => {
    const blob = await pdf(pdfDocumentComponent).toBlob();
    saveAs(blob, fileName);
};
  


  return (
    <LayoutMain
      idPage={`Detalle del brief: ${id}`}
      titlePage={true}
      className="main-center"
    >
      <section className="bc-container bc-card view-brief">
        {serviceQuery.isFetching && (
          <BcLoading messages={`Cargando Brief: ${id}`} />
        )}
        {serviceQuery.isError && <h1>Error</h1>}
        {serviceQuery.data && (
          <BCViewBrief>
            <div className="data-brief">
            <h1>{serviceQuery.data.name}</h1>
            <button
                    className="bc-button-primary bc-button-small btn-to-home"
                    type="button"
                    onClick={() => {
                        generatePdfDocument(`Brief-${serviceQuery.data.briefType}-${serviceQuery.data.id}.pdf`, <BcPdf briefContent={serviceQuery.data} />);
                    }}
                >
                    Descargar brief
                </button>
            </div>
            <section className="head-brief">
            <span>
                <p>
                  <strong className="question-brief">Tipo de brief:</strong> {serviceQuery.data.briefType}
                </p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">id:</strong> {serviceQuery.data.id}
                </p>
              </span>
              
              <span className="brief-status">
                <p>
                  <strong className="question-brief">Estado:</strong>
                </p>
                <BCTag status={serviceQuery.data.status} />
              </span>
              <span>
                <p>
                  <strong className="question-brief">Fecha Creación:</strong>{" "}
                  {serviceQuery.data.dateCreate}
                </p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">Fecha Edición:</strong> {serviceQuery.data.dateEdit}
                </p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">Version:</strong> {serviceQuery.data.version}
                </p>
              </span>
            </section>
            {/* Datos del brief */}
            <section>
              {serviceQuery.data.fields.pertenece_estrategia && (
                <span>
                  <p>
                    <strong className="question-brief">
                      ¿Pertenece a alguna estrategia de la pirámide?
                    </strong>
                  </p>
                  <p>{serviceQuery.data.fields.pertenece_estrategia}</p>
                </span>
              )}
              {serviceQuery.data.fields.descripcion && (
                <span>
                  <p>
                    <strong className="question-brief">
                    Describe tu requerimiento:
                    </strong>
                  </p>
                  <p>{serviceQuery.data.fields.descripcion}</p>
                </span>
              )}
              {serviceQuery.data.fields.fecha_salida && (
                <span>
                  <p>
                    <strong className="question-brief">
                    Fecha de salida:
                    </strong>
                  </p>
                  <p>{serviceQuery.data.fields.fecha_salida}</p>
                </span>
              )}
              {serviceQuery.data.fields.fecha_entrega && (
                <span>
                  <p>
                    <strong className="question-brief">
                    Fecha de estimada de entrega:
                    </strong>
                  </p>
                  <p>{serviceQuery.data.fields.fecha_entrega}</p>
                </span>
              )}
              <span>
                <p>
                  <strong className="question-brief">¿A qué nivel pertenece la campaña?</strong>
                </p>
                <p>{serviceQuery.data.fields.nivel}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">¿Cuál es el nombre de la campaña?</strong>
                </p>
                <p>{serviceQuery.data.fields.name}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">Indica nomenclatura para facturación:</strong>
                </p>
                <p>{serviceQuery.data.fields.nomenclatura}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">¿A qué marca pertenece la campaña?</strong>
                </p>
                <p>{serviceQuery.data.fields.marca}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">
                    ¿A que ciclo de vida de mercadeo pertenece la campaña?
                  </strong>
                </p>
                <p>{serviceQuery.data.fields.ciclo}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">¿Cuándo inicia la campaña?</strong>
                </p>
                <p>{serviceQuery.data.fields.fecha_inicio}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">¿Cuándo termina la campaña?</strong>
                </p>
                <p>{serviceQuery.data.fields.fecha_fin}</p>
              </span>
              <section className="brief-objetivos">
                <h2>Objetivos de mercadeo:</h2>
              {serviceQuery.data.fields.objetivo.map(
                (objetivo: any, index: number) => (
                  <div className="objetivo-detail" key={`Objetivo${index}`}>
                    <span>
                      <p>
                        <strong className="question-brief">Objetivo: </strong>
                      </p>
                      <p>{objetivo.objetivo}</p>
                    </span>
                  </div>
                )
              )}
              </section>
              <span>
                <p>
                  <strong className="question-brief">KRs:</strong>
                </p>
                <p>{serviceQuery.data.fields.krs}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">Estrategia macro:</strong>
                </p>
                <p>{serviceQuery.data.fields.estrategia_macro}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">
                    ¿A quién le vamos a hablar con esta campaña? Market place
                    (adressable):
                  </strong>
                </p>
                <p>{serviceQuery.data.fields.adressable}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">
                    ¿A quién le vamos a hablar con esta campaña? Perfil de la
                    audiencia / Buyer Persona
                  </strong>
                </p>
                <p>{serviceQuery.data.fields.audiencia}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">
                    ¿Cuál es el atributo de marca asociado a esta campaña?
                  </strong>
                </p>
                <p>{serviceQuery.data.fields.seasonality_mode}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">
                    ¿Qué espera que la audiencia piense, haga o sienta después
                    de estar expuesta / tener contacto con esta comunicación?
                  </strong>
                </p>
                <p>{serviceQuery.data.fields.audiencia_piensa}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">
                    ¿Por qué hoy esto no pasa? ¿Qué impide a nuestra audiencia
                    hacer, pensar o sentir esto?{" "}
                  </strong>
                </p>
                <p>{serviceQuery.data.fields.hoy_no}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">
                    ¿Qué tenemos para ofrecer que los motive a hacer lo que
                    queremos que hagan, piense o sienta? (diferencial,
                    beneficio, RTB){" "}
                  </strong>
                </p>
                <p>{serviceQuery.data.fields.que_tenemos}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">
                    ¿Existe algún competidor local y/o global que esté
                    ofreciendo lo mismo o un producto sustituto y en su criterio
                    lo esté haciendo bien? ¿Cuál? ¿Qué está haciendo? ¿por qué
                    lo está haciendo bien?{" "}
                  </strong>
                </p>
                <p>{serviceQuery.data.fields.competidor_local}</p>
              </span>
              <section className="brief-objetivos">
                <h2>Objetivos de medios</h2>
              {serviceQuery.data.fields.objetivos_medios.map(
                (objetivo: any, index: number) => (
                  <div className="objetivo-detail" key={`Objetivo${index}`}>
                    <span>
                      <p>
                        <strong className="question-brief">Tipo de objetivo: </strong>
                      </p>
                      <p>{objetivo.type}</p>
                    </span>
                    <span>
                      <p>
                        <strong className="question-brief">Etapa: </strong>
                      </p>
                      <p>{objetivo.etapa}</p>
                    </span>
                    <span>
                      <p>
                        <strong className="question-brief">Objetivos: </strong>
                      </p>
                      <p>{objetivo.objetivos}</p>
                    </span>
                  </div>
                )
              )}
              </section>
              <span>
                <p>
                  <strong className="question-brief">Presupuesto medios:</strong>
                </p>
                <p>{serviceQuery.data.fields.presupuesto_medios}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">Presupuesto producciones:</strong>
                </p>
                <p>{serviceQuery.data.fields.presupuesto_producciones}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">¿A que MDO se carga el ppto?</strong>
                </p>
                <p>{serviceQuery.data.fields.presupuesto_owner}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">
                    ¿Qué equipos (internos y externos) van a participar en este
                    proceso? ¿Cuál es el rol de cada uno?
                  </strong>
                </p>
                <p>{serviceQuery.data.fields.equipo}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">
                    ¿Para que países se requiren los derechos para utilizar las
                    piezas de la campaña?
                  </strong>
                </p>
                <p>{serviceQuery.data.fields.paises}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">
                    ¿Por cuánto tiempo se utilizarán las piezas de la campaña?
                  </strong>
                </p>
                <p>{serviceQuery.data.fields.tiempo}</p>
              </span>
              <span>
                <p>
                  <strong className="question-brief">Pre-read de negocio y producto:</strong>
                </p>
                <Link
                  className="bc-button-primary bc-button-small"
                  to={`/brief/descarga/${convertirABase64(serviceQuery.data.fields.preread)}`}
                  target="_blank"
                  rel="noopener"
                >
                  Descargar Archivo
                </Link>
              </span>
              <span>
                <p>
                  <strong className="question-brief">One page:</strong>
                </p>
                <Link
                  className="bc-button-primary bc-button-small"
                  to={`/brief/descarga/${convertirABase64(serviceQuery.data.fields.onepage)}`}
                  target="_blank"
                  rel="noopener"
                >
                  Descargar Archivo
                </Link>
              </span>
            </section>
          </BCViewBrief>
        )}
      </section>
    </LayoutMain>
  );
};

export default BriefView;
